import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { REQUEST_GET_USER_ACTIVE_PROJECT_TREE_DATA } from '../../Redux/constants/constants';
import { Table } from 'antd';
import prevMonthName from '../../Utils/prevMonthName';

const { Column } = Table;

const ActiveProjectsTreeTable = ({ userId }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.currentUserActiveProjectData);
  useEffect(() => {
    // TODO remove if statement when using formik and validation
    if (userId) {
      dispatch({
        type: REQUEST_GET_USER_ACTIVE_PROJECT_TREE_DATA,
        payload: { userId, status: 'active' },
      });
    }
  }, [userId]);

  return (
    <>
      <Table
        dataSource={data}
        expandRowByClick={true}
        rowKey={(record) => record.name + Math.random().toString()} // TODO cos okropnego
        pagination={false}
      >
        <Column title="Nazwa Projektu" dataIndex="name" key="name"></Column>
        <Column
          title={`Ilość godzin w ${prevMonthName}`}
          dataIndex="hoursLastMonth"
          key="hoursLastMonth"
        />
        <Column
          title="Całkowita ilość godzin"
          dataIndex="hoursTotal"
          key="hoursTotal"
        />
      </Table>
    </>
  );
};

export default ActiveProjectsTreeTable;
